import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const MapContainer = styled.div`
  position: relative;
  ${(props) => {
    // when in CCF we can't set full height (due to embedding into iframe),
    // so we lock the map to certain aspect ratios based on window sizes
    if (props.isCCF === true) {
      return CCFMapContainerSizingStyles;
    }

    return `height: 100vh;`;
  }}
`;

const CCFMapContainerSizingStyles = `
  // 1:1 on screens less than 480px
  aspect-ratio: 1/1;

  // 3:2 on screens 480px up to 768px
  @media (min-width: 480px) {
    aspect-ratio: 3/2;
  }

  // 4:3 on screens 768px up to 992px
  @media (min-width: 768px) {
    aspect-ratio: 4/3;
  }

  // 8:5 on screens 992px up to 1140px
  @media (min-width: 992px) {
    aspect-ratio: 8/5;
  }

  // 16:9 on screens 1140px or more
  @media (min-width: 1140px) {
    aspect-ratio: 16/9;
  }
`;

export const ProviderListWrapper = styled.div`
  margin: 0 ${fromTheme('spacing_large')};
`;

export const ErrorModalContainer = styled.div`
  padding: 0 0 ${fromTheme('spacing_medium')};
  @media (min-width: ${fromTheme('screen_medium')}) {
    padding: 20px 20px 40px;
  }
`;

export const BackToMapViewBtnWrapper = styled.span`
  position: absolute;
  z-index: 2;
  top: ${fromTheme('spacing_large')};
  left: ${fromTheme('spacing_large')};
`;
